import { NgModule } from '@angular/core';
import { CommonModule as AngularCore } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { ComponentsModule } from '../../../components/components.module';
import { PipesModule } from '../../../pipes/pipes.module';
import { LearnToolbarPanelComponent } from './learn-toolbar-panel.component';

@NgModule({
  imports: [
    AngularCore,
    TranslateModule.forChild(),
    ComponentsModule,
    PipesModule,
    LearnToolbarPanelComponent
  ],
  exports: [
    LearnToolbarPanelComponent
  ]
})
export class LearnToolbarPanelModule {
}

export {
  LearnToolbarPanelComponent
};

